import { stringToColor } from 'utils/strings/strings';
import { isBboxRegion, isPolygonRegion } from 'utils/typeguards/predictionOutputs';
import { convertPointAPIRegionToShapeProps, isPointRegion } from 'utils/annotations/point';

/**
 * Get shape props object based on region info type
 */
export function getShapeProps(region: CF.API.RegionsEntity, colorOverride?: string): CF.API.ShapeProps {
  if (isPointRegion(region.region_info)) {
    return convertPointAPIRegionToShapeProps(region, colorOverride);
  }

  if (isBboxRegion(region.region_info)) {
    return {
      bbox: region.region_info.bounding_box,
      color: colorOverride || stringToColor(region.data.concepts?.[0]?.id || region.id),
    };
  }

  return isPolygonRegion(region.region_info)
    ? {
        polygon: region.region_info.polygon,
        color: colorOverride || stringToColor(region.data.concepts?.[0]?.id || region.id),
      }
    : {
        mask: region.region_info.mask,
        color: colorOverride || stringToColor(region.data.concepts?.[0]?.id || region.id),
      };
}
